import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, catchError, map, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { StorageService } from './storage.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  putRequest(arg0: string, formValue: any): any {
    throw new Error('Method not implemented.');
  }
  loader: any;
  apiURL = environment.api_url;
  constructor(
    private readonly http: HttpClient,
    private readonly ngxUiLoaderService: NgxUiLoaderService,
   
    private readonly storageService: StorageService
  ) {
    this.loader = this.ngxUiLoaderService.getLoader();
  }

  private getHeaders() {
   
    return new HttpHeaders({
      'Content-Type': 'application/json',
    });
  }

  private getHeadersChat() {
   
    return new HttpHeaders({
      'Content-Type': 'multipart/form-data',
    });
  }

 getRequest(
  url: string,
  params: any,
  showLoader: boolean = false
): Observable<any> {

  let httpParams = new HttpParams();

  if (params) {
    Object.keys(params).forEach((key) => {
      if (params[key] !== null && params[key] !== undefined) {
        httpParams = httpParams.set(key, params[key]);
      }
    });
  }

  const options = {
    headers: this.getHeaders(),
    withCredentials: true,
    params: httpParams
  };

  return this.http.get(this.apiURL + url, options).pipe(
    map((response) => {
      if (showLoader) {
        setTimeout(() => this.ngxUiLoaderService.stop(), 100);
      }
      return response;
    })
  );
}


  postRequest(
    url: string,
    data: any,
    showLoader: boolean = false
  ): Observable<any> {
    showLoader = true;
    this.ngxUiLoaderService.start();

    return this.http
      .post(this.apiURL + url, data, {
        headers: this.getHeaders(),
        withCredentials: true,
      })
      .pipe(
        map((response) => {
          if (showLoader) setTimeout(() => this.ngxUiLoaderService.stop(), 200);
          return response;
        }),
        catchError((err) => {
          if (showLoader) setTimeout(() => this.ngxUiLoaderService.stop(), 200);
          return throwError(() => err);
        })
      );
  }

  postRequestChat(
    url: string,
    data: any,
    showLoader: boolean = false
  ): Observable<any> {
    if (showLoader) this.ngxUiLoaderService.start();

    return this.http
      .post(this.apiURL + url, data, {
        headers: this.getHeadersChat(),
        withCredentials: true,
      })
      .pipe(
        map((response) => {
          if (showLoader) setTimeout(() => this.ngxUiLoaderService.stop(), 200);
          return response;
        }),
        catchError((err, caught) => {
          if (showLoader) setTimeout(() => this.ngxUiLoaderService.stop(), 500);
          return throwError(() => err);
        })
      );
  }

  patchRequest(url: string, data?): Observable<any> {
    this.ngxUiLoaderService.start();
    return this.http
      .patch(this.apiURL + url, data, {
        headers: this.getHeaders(),
        withCredentials: true,
      })
      .pipe(
        map((response) => {
        this.ngxUiLoaderService.stop();
          return response;
        })
      );
  }

  updateRequest(url: string, data: any): Observable<any> {
    this.ngxUiLoaderService.start();
    return this.http
      .put(this.apiURL + url, data, {
        headers: this.getHeaders(),
        withCredentials: true,
      })
      .pipe(
        map((response) => {
          setTimeout(() => this.ngxUiLoaderService.stop(), 500);
          return response;
        })
      );
  }

  deleteRequest(url: string, data?: any): Observable<any> {
    this.ngxUiLoaderService.start();
    const options = {
      headers: this.getHeaders(),
      withCredentials: true,
      body: data,
    };
    return this.http.delete(this.apiURL + url, options).pipe(
      map((response) => {
        this.ngxUiLoaderService.stop();

        return response;
      })
    );
  }

  postRequestFile(api_url: string, data: FormData): Observable<any> {
     this.ngxUiLoaderService.start();
    const configForFile = {
      headers: new HttpHeaders({
        Authorization: this.storageService.get('token')
          ? 'Bearer ' + this.storageService.get('token')
          : '',
      }),
      withCredentials: true,
      responseType: 'arraybuffer' as 'json',
    };

    return new Observable((observer) => {
      this.http.post(this.apiURL + api_url, data, configForFile).subscribe(
        (data) => {
         this.ngxUiLoaderService.stop();
          observer.next(data);
          observer.complete();
        },
        (err) => {
          this.ngxUiLoaderService.stop();
          observer.error(err.error ? err.error.error : 'Unknown error');
        }
      );
    });
  }

  postRequestFilenew(api_url: string, data: any): Observable<any> {
    this.ngxUiLoaderService.start();
    const configForFile = {
      headers: new HttpHeaders({
        Authorization: this.storageService.get('token')
          ? 'Bearer ' + this.storageService.get('token')
          : '',
      }),
      withCredentials: true,
      responseType: 'arraybuffer' as 'json',
    };

    return new Observable((observer) => {
      this.http.post(this.apiURL + api_url, data, configForFile).subscribe(
        (data) => {
          this.ngxUiLoaderService.stop();
          observer.next(data);
          observer.complete();
        },
        (err) => {
          this.ngxUiLoaderService.stop();
          observer.error(err.error.error);
        }
      );
    });
  }

  updateRequestFile(api_url: string, data: FormData): Observable<any> {
    this.ngxUiLoaderService.start();
    const configForFile = {
      headers: new HttpHeaders({
        Authorization: this.storageService.get('token')
          ? 'Bearer ' + this.storageService.get('token')
          : '',
      }),
      withCredentials: true,
      responseType: 'arraybuffer' as 'json',
    };

    return new Observable((observer) => {
      this.http.put(this.apiURL + api_url, data, configForFile).subscribe(
        (data) => {
          this.ngxUiLoaderService.stop();
          observer.next(data);
          observer.complete();
        },
        (err) => {
          this.ngxUiLoaderService.stop();
          observer.error(err.error.error);
        }
      );
    });
  }

  getRequestFile(
    url: string,
    queryParams: { [key: string]: any } = {}
  ): Observable<any> {
    this.ngxUiLoaderService.start();
  
    const userToken = this.storageService.get('token');
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + userToken,
    });

    // Create HttpParams and append query parameters
    let params = new HttpParams();
    for (const key in queryParams) {
      if (queryParams.hasOwnProperty(key)) {
        params = params.append(key, queryParams[key]);
      }
    }

    return this.http
      .get(this.apiURL + url, {
        responseType: 'arraybuffer',
        headers: headers,
        params: params,
        withCredentials: true,
      })
      .pipe(
        map((response) => {
          setTimeout(() => this.ngxUiLoaderService.stop(), 500);
       
          return response;
        })
      );
  }

  downloadCSV(url: string, data: any, params?): Observable<any> {
    this.ngxUiLoaderService.start();
    if (params) {
      return this.http
        .post(this.apiURL + url, data, {
          params: params,
          responseType: 'arraybuffer',
        })
        .pipe(
          map((response) => {
            setTimeout(() => this.ngxUiLoaderService.stop(), 500);
            return response;
          })
        );
    } else {
      setTimeout(() => this.ngxUiLoaderService.stop(), 500);
      return this.http.post(this.apiURL + url, data, {
        responseType: 'arraybuffer',
      });
    }
  }
  postRequestFileJson(api_url: string, data: FormData): Observable<any> {
  this.ngxUiLoaderService.start();
  const config = {
    headers: new HttpHeaders({
      Authorization: this.storageService.get('token')
        ? 'Bearer ' + this.storageService.get('token')
        : '',
    }),
    withCredentials: true,
  };

  return this.http.post(this.apiURL + api_url, data, config).pipe(
    map((response) => {
      setTimeout(() => this.ngxUiLoaderService.stop(), 200);
      return response;
    }),
    catchError((err) => {
      setTimeout(() => this.ngxUiLoaderService.stop(), 200);
      return throwError(() => err);
    })
  );
}

updateRequestFileJson(api_url: string, data: FormData): Observable<any> {
  this.ngxUiLoaderService.start();
  const config = {
    headers: new HttpHeaders({
      Authorization: this.storageService.get('token')
        ? 'Bearer ' + this.storageService.get('token')
        : '',
    }),
    withCredentials: true,
  };

  return this.http.put(this.apiURL + api_url, data, config).pipe(
    map((response) => {
      setTimeout(() => this.ngxUiLoaderService.stop(), 200);
      return response;
    }),
    catchError((err) => {
      setTimeout(() => this.ngxUiLoaderService.stop(), 200);
      return throwError(() => err);
    })
  );
}
getRequestBlob(
  url: string,
  params?: any,
  showLoader: boolean = false
): Observable<Blob> {

  let httpParams = new HttpParams();

  if (params) {
    Object.keys(params).forEach((key) => {
      if (params[key] !== null && params[key] !== undefined) {
        httpParams = httpParams.set(key, params[key]);
      }
    });
  }

  if (showLoader) {
    this.ngxUiLoaderService.start();
  }

  return this.http.get(this.apiURL + url, {
    headers: this.getHeaders(),
    withCredentials: true,
    params: httpParams,
    responseType: 'blob'
  }).pipe(
    map((response: Blob) => {
      if (showLoader) {
        setTimeout(() => this.ngxUiLoaderService.stop(), 200);
      }
      return response;
    }),
    catchError((err) => {
      if (showLoader) {
        setTimeout(() => this.ngxUiLoaderService.stop(), 200);
      }
      return throwError(() => err);
    })
  );
}
}
